import React from 'react';
import { Table } from 'semantic-ui-react';

// Global Components
import { ADMIN, PAYROLL } from 'components/RoleGate/constants';
import RoleButtonLink from 'components/RoleButtonLink';
import PersonDatacomId from 'components/PersonDatacomId';
import PersonEmail from 'components/PersonEmail';
// @ts-ignore
import PersonFirstName from 'components/PersonFirstName';
// @ts-ignore
import PersonLastName from 'components/PersonLastName';
import PersonRoles from 'components/PersonRoles';
// @ts-ignore
import TableActions from 'components/TableActions';
import RoleTableRowLink from 'components/RoleTableRowLink';

// Child Components
// @ts-ignore
import PeopleGroupsList from './components/PeopleGroupsList';
import PersonDeleteLink from './components/PersonDeleteLink';

import { PersonModal } from '../../../../constants';
import PeopleTableCheckbox from '../PeopleTableCheckbox';

interface Props {
    personId?: number;
}

export default class PeopleTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { personId } = this.props;
        if (!personId) {
            return null;
        }
        return (
            <RoleTableRowLink
                params={{
                    selectedPerson: personId,
                    [PersonModal.PERSON_UPDATE_MODAL]: true
                }}
                requiredRoles={[ADMIN, PAYROLL]}
            >
                <Table.Cell>
                    <PeopleTableCheckbox rowId={personId} />
                </Table.Cell>
                <Table.Cell>
                    <PersonFirstName personId={personId} />
                </Table.Cell>
                <Table.Cell>
                    <PersonLastName personId={personId} />
                </Table.Cell>
                <Table.Cell>
                    <PersonDatacomId personId={personId} />
                </Table.Cell>
                <Table.Cell>
                    <PeopleGroupsList personId={personId} />
                </Table.Cell>
                <Table.Cell>
                    <PersonEmail personId={personId} />
                </Table.Cell>
                <Table.Cell>
                    <PersonRoles personId={personId} />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, PAYROLL]}
                            params={{
                                selectedPerson: personId,
                                [PersonModal.PERSON_UPDATE_MODAL]: true
                            }}
                        >
                            Edit
                        </RoleButtonLink>

                        <PersonDeleteLink personId={personId} />
                    </TableActions>
                </Table.Cell>
            </RoleTableRowLink>
        );
    }
}
